import { call, getContext, select } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { EId, ESource } from '../../../../repositories/deal-rent-announcements/v1/send-survey-answer';
import { TPollAction } from '../../../reducers/disableForms';
import { IAppState } from '../../../types';
import { selectOfferId } from '../../../../selectors/offer';
import { sendSurveyAnswer } from '../../../../services/sendSurveyAnswer';

export function* sendPollAnswer(action: TPollAction) {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');

  const state: IAppState = yield select();
  const offerId = selectOfferId(state);

  yield call(sendSurveyAnswer, {
    httpApi,
    logger,
    parameters: {
      offerId,
      id: EId.WhyDisableForms,
      answer: {
        values: action.payload,
      },
      source: ESource.AddForm,
    },
  });
}
